import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../constants/url";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Full list of categories with subcategories
const dataos = [
  {
    id: 269,
    name: "Admin",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.619Z",
    updatedAt: "2024-12-06T18:33:41.619Z",
    subcategories: [
      {
        id: 270,
        name: "Receptionist",
        parentId: 269,
        createdAt: "2024-12-06T18:33:41.623Z",
        updatedAt: "2024-12-06T18:33:41.623Z"
      },
      {
        id: 271,
        name: "Floor Manager",
        parentId: 269,
        createdAt: "2024-12-06T18:33:41.623Z",
        updatedAt: "2024-12-06T18:33:41.623Z"
      },
      {
        id: 272,
        name: "Assistant",
        parentId: 269,
        createdAt: "2024-12-06T18:33:41.623Z",
        updatedAt: "2024-12-06T18:33:41.623Z"
      }
    ]
  },
  {
    id: 181,
    name: "Hairstylists",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 193,
        name: "Texture Specialist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 194,
        name: "Extensions Specialist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 195,
        name: "Chemical Specialist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 196,
        name: "Bridal Hairstylist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 197,
        name: "Men’s Stylist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 198,
        name: "Natural Hair Stylist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 190,
        name: "Colorist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 191,
        name: "Stylist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 192,
        name: "Updo Specialist",
        parentId: 181,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 182,
    name: "Barbers",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 199,
        name: "Traditional Barber",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 200,
        name: "Fade Specialist",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 201,
        name: "Beard Specialist",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 202,
        name: "Clipper Cut Specialist",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 203,
        name: "Hair Tattoo Artist",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 204,
        name: "Hot Towel Shave Specialist",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 205,
        name: "Modern Barber",
        parentId: 182,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 183,
    name: "Tattoo Artists",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 206,
        name: "Black and Grey Specialist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 207,
        name: "Color Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 208,
        name: "Realism Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 209,
        name: "Traditional Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 210,
        name: "Neo-Traditional Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 211,
        name: "Japanese Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 212,
        name: "Portrait Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 213,
        name: "Biomechanical Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 214,
        name: "Watercolor Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 215,
        name: "Dotwork Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 216,
        name: "Geometric Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 217,
        name: "Minimalist Tattoo Artist",
        parentId: 183,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 184,
    name: "Estheticians",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 218,
        name: "Facialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 219,
        name: "Acne Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 220,
        name: "Waxing Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 221,
        name: "Microdermabrasion Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 222,
        name: "Chemical Peel Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 223,
        name: "Laser Technician",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 224,
        name: "Anti-Aging Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 225,
        name: "Body Treatment Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 226,
        name: "Brow and Lash Specialist",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 227,
        name: "Holistic Esthetician",
        parentId: 184,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 185,
    name: "Nail Technicians",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 228,
        name: "Manicurist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 229,
        name: "Pedicurist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 230,
        name: "Gel Nail Specialist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 231,
        name: "Acrylic Nail Specialist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 232,
        name: "Nail Art Specialist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 233,
        name: "Natural Nail Care Specialist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 234,
        name: "Spa Manicurist/Pedicurist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 235,
        name: "Nail Extension Specialist",
        parentId: 185,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 186,
    name: "Makeup Artists",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 236,
        name: "Bridal Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 237,
        name: "Editorial Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 238,
        name: "Special Effects Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 239,
        name: "Airbrush Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 240,
        name: "Celebrity Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 241,
        name: "Theatrical Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 242,
        name: "Film and TV Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 243,
        name: "Everyday Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 244,
        name: "Glam Makeup Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 245,
        name: "Cosmetic Tattoo Artist",
        parentId: 186,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 187,
    name: "Massage Therapists",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 246,
        name: "Swedish Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 247,
        name: "Deep Tissue Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 248,
        name: "Sports Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 249,
        name: "Prenatal Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 250,
        name: "Reflexologist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 251,
        name: "Trigger Point Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 252,
        name: "Hot Stone Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 253,
        name: "Aromatherapy Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 254,
        name: "Thai Massage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 255,
        name: "Myofascial Release Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 256,
        name: "Lymphatic Drainage Therapist",
        parentId: 187,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 188,
    name: "Eyelash Technicians",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 257,
        name: "Classic Lash Technician",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 258,
        name: "Volume Lash Technician",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 259,
        name: "Hybrid Lash Technician",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 260,
        name: "Lash Lift and Tint Specialist",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 262,
        name: "Lash Removal Specialist",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 263,
        name: "Lash Health Specialist",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 261,
        name: "Mega Volume Lash Technician",
        parentId: 188,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  },
  {
    id: 189,
    name: "Locticians",
    parentId: null,
    createdAt: "2024-12-06T18:33:41.601Z",
    updatedAt: "2024-12-06T18:33:41.601Z",
    subcategories: [
      {
        id: 264,
        name: "Starter Loc Specialist",
        parentId: 189,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 265,
        name: "Maintenance Loctician",
        parentId: 189,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 266,
        name: "Interlocking Specialist",
        parentId: 189,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 267,
        name: "Loc Extensions Specialist",
        parentId: 189,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      },
      {
        id: 268,
        name: "Micro Loc Specialist",
        parentId: 189,
        createdAt: "2024-12-06T18:33:41.606Z",
        updatedAt: "2024-12-06T18:33:41.606Z"
      }
    ]
  }
];

export default function DetailPageSalon() {
  const { id } = useParams();
  const [salonData, setSalonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(
          `${url}/api/admin/profile/salon/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSalonData(data.profile);
      } catch (error) {
        // If unauthorized, clear storage and redirect
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error("Error fetching salon profile:", error);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="p-4 md:p-6 bg-white rounded-3xl shadow-md">
        <Skeleton count={5} />
      </div>
    );
  }
  if (!salonData) return <p className="p-4">Failed to load salon data.</p>;

  const info = salonData.UserInformation || {};
  const salary = info.SalaryExps?.[0] || {};

  const portfolioImages = info.portfolio?.split(",").filter(Boolean) || [];

  // parse positions and services IDs
  const positions = (info.positionsOpen || "")
    .split(",")
    .map((v) => parseInt(v, 10))
    .filter(Boolean);
  const services = (info.categoriesId || "")
    .split(",")
    .map((v) => parseInt(v, 10))
    .filter(Boolean);

  // group by parent category for positions
  const positionItems = positions
    .map((id) => {
      // top-level match
      const top = dataos.find((c) => c.id === id);
      if (top) return { parentId: top.id, parentName: top.name, subName: null };
      for (const c of dataos) {
        const sub = (c.subcategories || []).find((s) => s.id === id);
        if (sub)
          return { parentId: c.id, parentName: c.name, subName: sub.name };
      }
      return null;
    })
    .filter(Boolean);

  const groupedPositions = positionItems.reduce((acc, item) => {
    if (!acc[item.parentId])
      acc[item.parentId] = { parentName: item.parentName, subs: [] };
    if (item.subName && !acc[item.parentId].subs.includes(item.subName)) {
      acc[item.parentId].subs.push(item.subName);
    }
    return acc;
  }, {});

  // group by parent category for services
  const serviceItems = services
    .map((id) => {
      const top = dataos.find((c) => c.id === id);
      if (top) return { parentId: top.id, parentName: top.name, subName: null };
      for (const c of dataos) {
        const sub = (c.subcategories || []).find((s) => s.id === id);
        if (sub)
          return { parentId: c.id, parentName: c.name, subName: sub.name };
      }
      return null;
    })
    .filter(Boolean);

  const groupedServices = serviceItems.reduce((acc, item) => {
    if (!acc[item.parentId])
      acc[item.parentId] = { parentName: item.parentName, subs: [] };
    if (item.subName && !acc[item.parentId].subs.includes(item.subName)) {
      acc[item.parentId].subs.push(item.subName);
    }
    return acc;
  }, {});

  // format working days to short form
  const daysArray = (salary.workingDays || "").split(",").map((d) => d.trim());
  const dayMap = {
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
    Sunday: "Sun"
  };
  const workingDaysDisplay = daysArray
    .map((d) => dayMap[d] || d.slice(0, 3))
    .join(" , ");

  console.log("salary", salary);

  return (
    <div className="p-4 md:p-6 bg-white rounded-3xl shadow-md relative">
      {/* Header */}
      <div className="flex flex-col items-center text-center mb-6">
        <img
          src={info.profile || "https://via.placeholder.com/150"}
          alt={salonData.fullName}
          className="w-40 h-40 rounded-full mb-4 object-cover shadow-md"
        />
        <h1 className="text-2xl md:text-3xl font-semibold mb-1">
          {salonData.fullName}
        </h1>
        <p className="text-gray-600 mb-1">
          {info.city || "Unknown City"}, {info.state || "Unknown State"}
        </p>
        <p className="text-sm text-gray-500">{salonData.email}</p>
      </div>

      {/* About */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">About</h2>
        <p>{info.about || "No about information provided."}</p>
      </section>

      {/* Positions Available */}
      <section className="mb-6 bg-gray-100 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">Positions Available</h2>
        {Object.values(groupedPositions).map((group) => (
          <div key={group.parentName} className="mb-4">
            <h3 className="text-lg font-medium mb-1">{group.parentName}</h3>
            {group.subs.length > 0 && (
              <ul className="list-disc list-inside ml-4">
                {group.subs.map((sub) => (
                  <li key={sub}>{sub}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </section>

      {/* Services We Offer */}
      <section className="mb-6 bg-gray-100 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">Services We Offer</h2>
        {Object.values(groupedServices).map((group) => (
          <div key={group.parentName} className="mb-4">
            <h3 className="text-lg font-medium mb-1">{group.parentName}</h3>
            <ul className="list-disc list-inside ml-4">
              {group.subs.map((sub) => (
                <li key={sub}>{sub}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <h2 className="text-xl font-semibold mb-2">Packages Available</h2>
      {/* Packages */}
      <section className="mb-6 bg-gray-200 p-4 rounded-lg grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-white border rounded-lg">
          <strong>Booth Rent:</strong> Not more than ${salary.boothRent}/wk
        </div>
        <div className="p-4 bg-white border rounded-lg">
          <strong>Commission:</strong> Not less than {salary.commission}%
        </div>
        <div className="p-4 bg-white border rounded-lg">
          <strong>Salary:</strong> Not less than ${salary.salary}/yr
        </div>
        <div className="p-4 bg-white border rounded-lg">
          <strong>Hourly:</strong> Not less than ${salary.hourly}/hr
        </div>
        <div className="p-4 bg-white border rounded-lg">
          <strong>Lease Fee:</strong> Not more than ${salary.leaseFee}/mo
        </div>
      </section>
      {/* Working Days */}
      <section className="mb-6 bg-gray-100 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-2">Operation Days and Hours</h2>
        <p className="p-4 bg-white border rounded-lg">
          {workingDaysDisplay || "Not specified"}
        </p>
        <div className="mt-2 grid grid-cols-2 gap-4">
          <div className="p-4 bg-white border rounded-lg">
            <strong>Start Time:</strong> {salary.startTime}
          </div>
          <div className="p-4 bg-white border rounded-lg">
            <strong>End Time:</strong> {salary.endTime}
          </div>
        </div>
      </section>

      {/* Subscription */}
      <h2 className="text-xl font-semibold mb-2">Subscription</h2>

      {salonData.Subscription?.[0] && (
        <section className="mb-6 bg-gray-200 p-4 rounded-lg grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 bg-white border rounded-lg">
            <strong>Name:</strong> {salonData.Subscription[0].name}
          </div>
          <div className="p-4 bg-white border rounded-lg">
            <strong>Price:</strong> ${salonData.Subscription[0].price}
          </div>
          <div className="p-4 bg-white border rounded-lg">
            <strong>Expires:</strong>{" "}
            {new Date(salonData.Subscription[0].expiry).toLocaleDateString()}
          </div>
        </section>
      )}

      <section className="mb-20">
        <h2 className="text-xl font-semibold mb-2">Saloon Pictures</h2>
        {portfolioImages.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {portfolioImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Portfolio ${idx + 1}`}
                className="w-full h-40 object-cover rounded-md cursor-pointer hover:opacity-90"
                onClick={() => setSelectedImage(img)}
              />
            ))}
          </div>
        ) : (
          <p>No portfolio images available.</p>
        )}
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white p-4 rounded-2xl shadow-xl max-w-3xl w-full mx-4 md:mx-0"
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-2 right-4 text-[#AF9C80] text-3xl font-bold hover:text-black"
            >
              &times;
            </button>
            <img
              src={selectedImage}
              alt="Salon Full View"
              className="w-full h-auto rounded-b-2xl"
            />
          </div>
        </div>
      )}

      {/* Footer Buttons */}
      {/* <div className="sm:absolute bottom-4 right-4 flex space-x-2">
        <button className="p-2 bg-red-500 text-white rounded-full">
          Block User
        </button>
        <button className="p-2 bg-yellow-500 text-white rounded-full">
          Suspend User
        </button>
      </div> */}
    </div>
  );
}
